import * as Sentry from '@sentry/react';
import { config } from '../config/config';

let initialized = false;

export function initMonitoring(): void {
  if (initialized || !config.sentryDsn || !config.sentryEnabled) {
    return;
  }

  Sentry.init({
    dsn: config.sentryDsn,
    environment: config.sentryEnvironment,
    release: config.sentryRelease,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: config.sentryTracesSampleRate,
    sendDefaultPii: false,
    beforeSend(event) {
      if (event.request?.headers) {
        delete event.request.headers.authorization;
        delete event.request.headers.Authorization;
        delete event.request.headers['x-api-key'];
      }
      return event;
    },
  });

  syncMonitoringContext();
  initialized = true;
}

export function syncMonitoringContext(): void {
  if (!initialized) {
    return;
  }

  const userId = localStorage.getItem('userId');
  const eventId = localStorage.getItem('eventId');

  Sentry.setUser(
    userId
      ? {
          id: userId,
        }
      : null,
  );

  Sentry.setTag('event_id', eventId || 'none');
  Sentry.setContext('app', {
    eventId: eventId || null,
    path: window.location.pathname,
  });
}

export function clearMonitoringUser(): void {
  if (!initialized) {
    return;
  }

  Sentry.setUser(null);
  Sentry.setTag('event_id', 'none');
}

export function captureAppError(
  error: unknown,
  context?: Record<string, unknown>,
): void {
  if (!initialized) {
    return;
  }

  syncMonitoringContext();
  Sentry.captureException(error, context ? { extra: context } : undefined);
}

export function captureAppMessage(
  message: string,
  level: Sentry.SeverityLevel = 'error',
  context?: Record<string, unknown>,
): void {
  if (!initialized) {
    return;
  }

  syncMonitoringContext();
  Sentry.captureMessage(message, {
    level,
    extra: context,
  });
}
